import NARCAN_LOGO from '../assets/images/NARCAN-Logo_White.png';
import NARCAN_LOGO_BLACK from '../assets/images/NARCAN-Logo_Black.png';
import NARCAN_PRODUCT from '../assets/images/narcan_product.png';
import NARCAN_LANDING from '../assets/images/narcan_landing.png';
import FFF_LOGO_FOOTER_BOAT from '../assets/images/footer-logo-fff.png';
import WALL_KIT_PRODUCT from '../assets/images/wall_unit.png';
import CAROUSEL_IMAGES_NARCAN_ONE from '../assets/images/carousel-images/naloxone1.png';

import CAROUSEL_IMAGES_NARCAN_ONE_NEW from '../assets/images/narcan-carousel-images-new/narcan1.jpg';
import CAROUSEL_IMAGES_NARCAN_TWO_NEW from '../assets/images/narcan-carousel-images-new/narcan2.jpg';
import CAROUSEL_IMAGES_NARCAN_THREE_NEW from '../assets/images/narcan-carousel-images-new/narcan3.jpg';
import CAROUSEL_IMAGES_NARCAN_FOUR_NEW from '../assets/images/narcan-carousel-images-new/narcan4.jpg';

import CAROUSEL_IMAGES_WALL_UNIT_ONE_NEW from '../assets/images/wall-unit-new/wall-unit1.jpg';
import CAROUSEL_IMAGES_WALL_UNIT_TWO_NEW from '../assets/images/wall-unit-new/wall-unit2.jpg';
import CAROUSEL_IMAGES_WALL_UNIT_THREE_NEW from '../assets/images/wall-unit-new/wall-unit3.jpg';

import NARCAN_CASE_ONE from '../assets/images/narcan-case/narcan-case-front-angle.png';
import NARCAN_CASE_TWO from '../assets/images/narcan-case/narcan-case-front.png';
import NARCAN_CASE_THREE from '../assets/images/narcan-case/narcan-case-open-device.png';
import NARCAN_CASE_FOUR from '../assets/images/narcan-case/narcan-case-top-open.png';

export const IMAGES_URL = {
    NARCAN_LOGO: NARCAN_LOGO,
    NARCAN_LOGO_BLACK: NARCAN_LOGO_BLACK,
    NARCAN_PRODUCT: NARCAN_PRODUCT,
    NARCAN_LANDING: NARCAN_LANDING,
    FFF_LOGO_FOOTER_BOAT: FFF_LOGO_FOOTER_BOAT,
    WALL_KIT_PRODUCT: WALL_KIT_PRODUCT
};

export const CAROUSEL_IMAGES_NARCAN_URL = {
    CAROUSEL_IMAGES_NARCAN_ONE: CAROUSEL_IMAGES_NARCAN_ONE,
    CAROUSEL_IMAGES_WALL_UNIT_ONE: WALL_KIT_PRODUCT
};

export const CAROUSEL_IMAGES_NARCAN_NEW = {
	CAROUSEL_IMAGES_NARCAN_ONE_NEW: CAROUSEL_IMAGES_NARCAN_ONE_NEW,
	CAROUSEL_IMAGES_NARCAN_TWO_NEW: CAROUSEL_IMAGES_NARCAN_TWO_NEW,
	CAROUSEL_IMAGES_NARCAN_THREE_NEW: CAROUSEL_IMAGES_NARCAN_THREE_NEW,
	CAROUSEL_IMAGES_NARCAN_FOUR_NEW: CAROUSEL_IMAGES_NARCAN_FOUR_NEW
}

export const CAROUSEL_IMAGES_WALL_UNIT_NEW = {
	CAROUSEL_IMAGES_WALL_UNIT_ONE_NEW: CAROUSEL_IMAGES_WALL_UNIT_ONE_NEW,
	CAROUSEL_IMAGES_WALL_UNIT_TWO_NEW: CAROUSEL_IMAGES_WALL_UNIT_TWO_NEW,
	CAROUSEL_IMAGES_WALL_UNIT_THREE_NEW: CAROUSEL_IMAGES_WALL_UNIT_THREE_NEW
}

export const CAROUSEL_IMAGES_NARCAN_CASE = {
    NARCAN_CASE_ONE: NARCAN_CASE_ONE,
    NARCAN_CASE_TWO: NARCAN_CASE_TWO,
    NARCAN_CASE_THREE: NARCAN_CASE_THREE,
    NARCAN_CASE_FOUR: NARCAN_CASE_FOUR
}